var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * React Query hook for paginated building data with infinite scroll
 */
import { useInfiniteQuery } from '@tanstack/react-query';
import BuildingService from './BuildingService';
export const BUILDINGS_QUERY_KEY = ['buildings-paginated'];
/**
 * Hook to fetch paginated buildings with infinite scroll support
 */
export function usePaginatedBuildings({ pageSize = 20, filter = '', enabled = true } = {}) {
    return useInfiniteQuery({
        queryKey: [...BUILDINGS_QUERY_KEY, { filter, pageSize }],
        queryFn: (_a) => __awaiter(this, [_a], void 0, function* ({ pageParam = 1 }) {
            const params = {
                take: pageSize,
                skip: (pageParam - 1) * pageSize,
                page: pageParam,
                pageSize,
                filter: filter || undefined
            };
            const response = yield BuildingService.getBuildings(params);
            return {
                data: response.data,
                totalCount: response.totalCount,
                hasMore: response.hasMore,
                nextPage: response.hasMore ? pageParam + 1 : undefined
            };
        }),
        getNextPageParam: (lastPage) => lastPage.nextPage,
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 3,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
        enabled
    });
}
